import DataObj from "./DataObj";
import StringUtils from "../helper/StringUtils";
import TimeUtils from "../helper/TimeUtils";
import SubTitleUtils from "../helper/SubTitleUtils";
import WaveformView from "../components/drogable/WaveformView";

class DataObjArray {
  constructor() {
    //fIsRemoveContinuousWhitespace
    this.dataArry = [];
    this.StyleData = null;
  }

  init() {}

  //底部追加
  append_empty_Row() {}

  /**
   * 用在初始資料
   * @param {*} dataObjArray 從 import 帶入的data
   */ 
  setImportInitArray(dataObjArray) {
    this.dataArry = [];

    var index = 0;
    dataObjArray.map((data) => {
      const newObj = new DataObj(data);
      newObj.setTSubType(WaveformView.projectSubType);

      this.dataArry.push(newObj);

      index += 1;
    });
  }

  /**
   * 一般情況初始資料
   * @param {*} dataObjArray 從this.props.editTable 帶入的data
   */ 
  setArray(dataObjArray) {
    this.dataArry = [];

    var index = 0;
    dataObjArray.map((data) => {
      const newObj = new DataObj(data);
      newObj.setTSubType(WaveformView.projectSubType);

      this.dataArry.push(newObj);

      index += 1;
    });
  }

  setStyle(StyleData) {
    this.StyleData = StyleData;
  }

  //在一開專案的時候檢查 In Out
  checkInAndOutAtBegin() {
    let newDataArry = [];
    this.dataArry.map((data) => {
      const { In, Out } = data;

      let newObj = data;

      newObj.setInOut("In", In);
      newObj.setInOut("Out", Out);
      newDataArry.push(newObj);
    });
    this.dataArry = newDataArry;
  }

  setArray_from_Import(dataObjArray) {
    // {
    //     "id": 1,
    //     "start": 13.375,
    //     "end": 15.417,
    //     "text": "請往這邊疏散 不要推擠"
    // },
    this.dataArry = [];
    dataObjArray.map((data) => {
      const { start, end, text } = data;

      let newObj = new DataObj();
      newObj.setTSubType(WaveformView.projectSubType);

      newObj.setInOut("In", parseFloat(start));
      newObj.setInOut("Out", parseFloat(end));
      newObj.setSubtitleCaption(text);

      this.dataArry.push(newObj);
    });
  }
  getLength() {
    return this.dataArry.length;
  }

  addTenRow() {
    for (let i = 0; i < 10; i++) {
      let empRow = new DataObj();
      empRow.setTSubType(WaveformView.projectSubType);

      this.dataArry.push(empRow);
    }
  }

  //增加底部 空Row
  addEmpRow() {
    const emp = new DataObj();
    emp.setTSubType(WaveformView.projectSubType);

    this.dataArry.push(emp);
  }

  //直接拉表格的內容過來更新
  setArray_from_table(dataObjArray) {}

  //移除多個物件
  delete_mutile_Row(startRow, totlaCount) {
    this.dataArry.splice(startRow, totlaCount);
  }

  //新增空物件
  add_empty_Row(Rowindex) {
    let empDataObj = new DataObj();
    empDataObj.setTSubType(WaveformView.projectSubType);

    this.dataArry.splice(Rowindex, 0, empDataObj);
  }

  getContent() {
    return this.dataArry;
  }

  getObj(index) {
    return this.dataArry[index];
  }
  getContentLength() {
    return this.dataArry.length;
  }

  //個別更新 時間
  updateDataObj_by_index(index, newObj) {
    // const data = new DataObj(newObj)
    this.dataArry[index] = newObj;
  }

  //一次性更新所有資料
  updateByAllChange(change) {
    change.forEach(([row, prop, oldValue, newValue]) => {
      if (oldValue !== newValue) {
        const key = prop;
        if (
          key === "In" ||
          key === "Out" ||
          key === "Memo" ||
          key === "SubtitleCaption"
        ) {
          //主資料更新
          this.updateChange(row, prop, oldValue, newValue);
        }
      }
    });
  }

  //進行 isInputLatencyAct 檢察
  checkInputLatency(row, inputLatencyFrameNum, videoFps) {
    let currentObj = new DataObj(this.dataArry[row]);
    currentObj.setTSubType(WaveformView.projectSubType);

    let currentframe = TimeUtils.timeString_convertTo_frame(currentObj.In);
 
    if ((currentframe + 1) >= inputLatencyFrameNum) {
      let newTimeString = TimeUtils.getTimeStringFrom_Frame_deduction(
        currentObj.In,
        -1 * inputLatencyFrameNum,
        videoFps
      );

      //console.log(`新時間 ${newTimeString}`)
      //IN
      currentObj.setInOut("In", newTimeString,currentObj.In);
      this.dataArry[row] = currentObj;
    }
  }

  //表單傳來更新
  updateChange(row, prop, oldValue, newValue) {
    let currentObj = new DataObj(this.dataArry[row]);
    currentObj.setTSubType(WaveformView.projectSubType);

    // this.In = "";
    // this.Out = "";
    // this.start = "";
    // this.end = "";
    // this.ShotChange ="";
    // this.Duration = "";
    // this.Memo = "";
    // this.Source = "";
    // this.SubtitleCaption = "";
    // this.Length = "";
    // this.Position = "";
    if (prop === "In") {
      // 如果不相同 處理
      if (!StringUtils.checkStringNotDifferent(newValue, oldValue)) {
        currentObj.setInOut("In", newValue, oldValue);
      }
    }
    if (prop === "Out") {
      // 如果不相同 處理
      if (!StringUtils.checkStringNotDifferent(newValue, oldValue)) {
        currentObj.setInOut("Out", newValue, oldValue);
      }
    }
    if (prop === "Memo") {
      currentObj.Memo = newValue;
    }
    if (prop === "Source") {
      currentObj.Source = newValue;
    }
    if (prop === "SubtitleCaption") {
      //fIsRemoveContinuousWhitespace
      if (this.StyleData.fIsRemoveContinuousWhitespace === 1) {
        //要主動移除多的空格
      }
      currentObj.setSubtitleCaption(newValue);
    }
    if (prop === "Position") {
      currentObj.Position = newValue;
    }

    this.dataArry[row] = currentObj;
  }

  //複製到
  copyToSource() {
    let newDataArry = [];
    this.dataArry.map((data) => {
      const newObj = new DataObj(data);
      newObj.setTSubType(WaveformView.projectSubType);
      newObj.copySource();
      newDataArry.push(newObj);
    });

    this.dataArry = newDataArry;
  }

  //新增shot change
  // addShotArray(shotArray){
  //     shotArray.map(shotdata=>{
  //         let rangeArray = this.dataArry.filter(data=>(parseFloat(data["start"]) <= shotdata && parseFloat(data["end"]) >= shotdata) );

  //          rangeArray.map(dataObj=>{
  //             dataObj.setShotChange(shotdata);
  //         })
  //     })
  // }

  //檢查不完整的In Out
  IncompleteInspection() {
    let index = 1;
    let checkIndexArray = [];
    this.dataArry.map((data) => {
      const newObj = new DataObj(data);
      newObj.setTSubType(WaveformView.projectSubType);

      //如果 in Out其中一個不是空值得話
      if (newObj.In !== "" || newObj.Out !== "") {
        //檢查格式
        let isInEnable = true;
        if (
          newObj.In.includes(":") === true &&
          newObj.In.includes(".") === true &&
          newObj.Out.includes(":") === true &&
          newObj.Out.includes(".") === true
        ) {
          //過關
          isInEnable = true;
        } else {
          isInEnable = false;
        }

        if (isInEnable === false) {
          checkIndexArray.push(index);
        }
      }

      index++;
    });

    return checkIndexArray;
  }
}

export default DataObjArray;



// WEBPACK FOOTER //
// ./src/class/DataObjArray.js